export { tl, TIERS, FEE_KURUS, TIER_KEYS, type Tier, type TierPrices } from '../../../src/domain/pricing';
export { dayShort, dayLong, hhmm, weekdayShort, dateNum, istMidnight, dateNumMon } from '../../../src/domain/time';
export { seatLabel } from '../../../src/domain/layout';
export const nf = (n: number, lang: 'tr' | 'en' = 'tr') => Math.round(n).toLocaleString(lang === 'en' ? 'en-GB' : 'tr-TR');
export const mmss = (ms: number) => {
  const t = Math.max(0, Math.ceil(ms / 1000));
  return String(Math.floor(t / 60)).padStart(2, '0') + ':' + String(t % 60).padStart(2, '0');
};
